import errorContext from './errorContext';

const reducers = {
  errorContext,
};

export default reducers;
